"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const TooltipIcon_1 = __importDefault(require("../TooltipIcon"));
const makeMyClasses = (color, variant, weight, withBreaks, withEllipsis, noWrap, centered, right) => ({
    root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, variants[variant]), (centered ? centeredBit : {})), (right ? rightBit : {})), (withBreaks ? breaksBit : {})), (withEllipsis ? ellipsisBit : {})), (noWrap ? noWrapBit : {})), { color: color ? (typeof color === 'string' ? colors[color] : color.main) : undefined }), (weight ? weightBit : {})), { '& p': {
            display: 'inline',
        }, '& a': {
            transition: 'color 0.33s',
            color: lib_palette_1.default.secondary.main,
            fontWeight: 700,
        }, '& a:hover': {
            color: lib_palette_1.default.primary.main,
        }, transition: 'color 0.3s' }),
});
exports.Text = react_1.default.forwardRef((props, ref) => {
    const { variant = 'body', color = 'inherit', weight = false, withBreaks = false, withEllipsis = false, noWrap = false, centered = false, right = false, children = '', className, onKeyDown, onClick, style, tip, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [
        color,
        variant,
        weight,
        withBreaks,
        withEllipsis,
        noWrap,
        centered,
        right,
    ]);
    return (0, react_1.useMemo)(() => {
        if (!tip)
            return (react_1.default.createElement(Typography_1.default, { ref: ref, style: style, className: (0, web_css_1.cx)(myCss.root, className), onKeyDown: onKeyDown, onClick: onClick, component: "div" }, children));
        return (react_1.default.createElement(Typography_1.default, { ref: ref, style: Object.assign(Object.assign({}, style), { display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }), className: (0, web_css_1.cx)(myCss.root, className), onKeyDown: onKeyDown, onClick: onClick, component: "div" },
            children,
            !!tip && react_1.default.createElement(TooltipIcon_1.default, { style: { margin: '2px 0 0 4px' }, tip: tip })));
    }, [tip, ref, style, myCss.root, className, onKeyDown, onClick, children]);
});
exports.default = exports.Text;
const breaksBit = {
    whiteSpace: 'pre-line',
};
const ellipsisBit = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};
const noWrapBit = {
    whiteSpace: 'nowrap',
};
const centeredBit = {
    textAlign: 'center',
};
const rightBit = {
    textAlign: 'right',
};
const weightBit = {
    fontFamily: 'Gilroy',
};
const colors = {
    dark: lib_palette_1.default.Liquorice.main,
    light: lib_palette_1.default.WhiteSmoke.main,
    darkgrey: lib_palette_1.default.BlackCoral.main,
    grey: lib_palette_1.default.GreyBlue.main,
    lightgrey: lib_palette_1.default.LavendarGrey.main,
    link: lib_palette_1.default.secondary.dark,
    pink: lib_palette_1.default.primary.main,
    white: lib_palette_1.default.White.main,
    error: lib_palette_1.default.error.main,
};
const variants = {
    small: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
    },
    tiny: {
        fontSize: 10,
        fontWeight: 500,
        lineHeight: '12px',
    },
    teeny: {
        fontSize: 8,
        fontWeight: 500,
        lineHeight: '10px',
    },
    body: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '19px',
    },
    h0: {
        fontSize: 24,
        fontWeight: 700,
        lineHeight: '26px',
    },
    h1: {
        fontSize: 18,
        fontWeight: 700,
        lineHeight: '22px',
    },
    h2: {
        fontSize: 15,
        fontWeight: 700,
        lineHeight: '22px',
    },
    h3: {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '19px',
    },
};
